import styled from 'styled-components';
import { headerHeight, toogleHeight } from 'utils/styleConstants';

export const StyledMenu = styled.menu`
  overflow: hidden;
  height: calc(100vh - ${headerHeight + toogleHeight}px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0;
  padding: 0;
`;

export const SearchContainer = styled.div<{ isMenuOpen: boolean }>`
  padding: ${({ isMenuOpen }) => (isMenuOpen ? '15px 10px' : '10px 2px')};
  z-index: ${({ theme }) => theme.zIndexPalette.medium};
  display: flex;
  justify-content: ${({ isMenuOpen }) => (isMenuOpen ? 'flex-start' : 'center')};
`;

export const IconSearchContainer = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  &:hover {
    cursor: pointer;
    background-color: ${({ theme }) =>
      `${
        theme.colorPalette.isDarkMode
          ? theme.colorPalette.withOpacity(theme.colorPalette.grey.grey9, 0.1)
          : theme.colorPalette.withOpacity(theme.colorPalette.grey.grey5, 0.2)
      }`};
  }
`;

export const MenuContainer = styled.div<{ isMenuOpen: boolean }>`
  width: 100%;
  padding: 10px 6px 0 6px;
  background-color: ${({ theme }) =>
    theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey2 : theme.colorPalette.white};
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 10px;
  background-color: ${({ theme }) =>
    theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey2 : theme.colorPalette.white};
  flex-shrink: 0;
  height: 10px;
`;

export const TextVersion = styled.p`
  color: ${({ theme }) => theme.colorPalette.grey.grey9};
  font-weight: ${({ theme }) => theme.fontWeightPalette.light};
  font-size: ${({ theme }) => theme.fontSizePalette.xxSmall};
  text-align: left;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
`;
